var $f9e155e6e8cacaa2$exports = {};
$f9e155e6e8cacaa2$exports = {
  "Empty": "\u05E8\u05D9\u05E7"
};
export { $f9e155e6e8cacaa2$exports as default };